import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PopupWrapper from "../Common/PopupWrapper";
import i18next from "i18next";
import {renderHTML} from "@mnjsplatform/data/lib/utils/htmlUtils";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import ScheduleVacationList from "./ScheduleVacationList";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";

class VacationForm extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isDataReady: false,
            rowIndex: null,
            showScheduleVacationForm: false
        }
    }

    componentDidMount() {
        this.initialize();
    }

    initialize = async () => {
        //console.log(`this.props.rowKey: ${JSON.stringify(this.props.rowKey)}`);
        let rowIndex;
        if (this.props.addMode) {
            await this.props.dispatch(this.props.dataItem.beginAdd());
            rowIndex = this.props.dataItem.rowInEditIndex;
        } else {
            await this.props.dispatch(this.props.dataItem.beginEdit(rowIndex));
            rowIndex = this.props.dataItem.getRowIndex(this.props.rowKey);
        }
        this.setState({isDataReady: true, rowIndex: rowIndex});
    }

    onSave = async (e) => {
        if (e) e.preventDefault();
        if (this.props.addMode) {
            await this.props.dispatch(this.props.dataItem.saveAdd(this.state.rowIndex));
        } else {
            await this.props.dispatch(this.props.dataItem.save(this.state.rowIndex));
        }
        if (!this.props.dataItem.isError) {
            this.props.hideEditor();
            this.props.refreshDataItem();
        }
    }

    onCancel = async (e) => {
        if (e) e.preventDefault();
        if (this.props.addMode) {
            const key = this.props.dataItem.getField(this.state.rowIndex, 'ItemImageIntId');
            console.log(`key: ${JSON.stringify({ItemImageIntId: key})}`);
            if (key) {
                await this.props.dispatch(this.props.HolidayAppItemImage_Drop.execute({ItemImageIntId: key}));
            }
            await this.props.dispatch(this.props.dataItem.cancelAdd());
        } else {
            await this.props.dispatch(this.props.dataItem.cancelEdit());
        }
        this.props.hideEditor();
        this.props.refreshDataItem();
    }

    showScheduleVacation = async() => {
        const numYear = this.getNumYear();
        if(!numYear){
            throw new Error("Vacation_Form_1");
        }
        let key = {"NumYear": numYear};
        await this.props.dispatch(this.props.ShedHolidayDetailListForPO.reset());
        await this.props.dispatch(this.props.ShedHolidayDetailListForPO.execute(key, {withStyle: true}));
        this.setState({showScheduleVacationForm: true});
    }

    renderButtons = () => {
        return (<div className="modal-footer text-right">
            <div className="text-right">
                <button className="btn btn-regular -goahead ml1ex"
                        onClick={this.showScheduleVacation}>{i18next.t("Vacation_Form_2")} </button>
                <button className="btn btn-regular -goahead ml1ex" onClick={this.onSave}>{i18next.t('Save')} </button>
                &nbsp;
                <button className="btn btn-regular" onClick={this.onCancel}>{i18next.t('Cancel')}</button>
            </div>
        </div>);
    }

    refreshDataItem = async () => {
        await this.props.dispatch(this.props.dataItem.refresh());
    }
    getNumYear = () => {
        let dateBegin =  this.props.dataItem.getField(0, 'HolDateBegin');
        if(!dateBegin){
            dateBegin = this.props.dataItem.getField(0, 'DateBegin');
        }
        return  new Date(dateBegin).getFullYear();
    }
    paramRender = (h) => {
        const getClass = (stateFactPlan) => {
            switch (stateFactPlan) {
                case 1: return 'danger';
                case 2: return 'success';
                case 3: return 'info';
                default: return 'light';
            }
        }
        const needScans = h.row.ScanDesc !== null;
        return (<div className="row">
            <div className="col-md-12">
                {h.fs.map((fi) => {
                    const fn = fi.Name;
                    if (this.props.addMode) {
                        if (fi.Name === 'V_DocListScan') {
                            return null;
                        }
                    }
                    if (!needScans && (fi.Name === 'ScanDesc' || fi.Name === 'V_DocListScan')) {
                        return null;
                    }
                    return (<React.Fragment key={fn}>
                        <div className="row">
                            <div className="col-md-3 field-title">
                                {h.lbl(fn)}
                            </div>
                            <div className="col-md-9">
                                {(fi.Name === 'ScanDesc' ? renderHTML(h.row.ScanDesc) : h.ed(fn))}
                                {(fi.Name === 'ScanDesc' && this.props.addMode ? <span
                                    className="text-danger"><br/>{i18next.t("Vacation_Form_3")}</span> : null)}
                            </div>
                        </div>
                        <hr/>
                    </React.Fragment>)
                })}
            </div>
            {h.row.StateFactPlan && h.row.StateFactPlan !== 0 &&
                <div className="row">
                    <div className="col-md-12">
                        <div role="alert" className={"alert alert-" + getClass(h.row.StateFactPlan)}> {h.row.StateFactPlanMsg}</div>
                    </div>
                </div>
            }
        </div>)
    }

    render() {
        if (!this.state.isDataReady) return null;

        return (<><PopupWrapper popupVisible={true}
                                title={i18next.t((this.props.addMode ? "AddVacation" : "Edit"), {title: this.props.title})}
                                staticTitle={i18next.t('AddVacation')}
                                onClose={this.onCancel} renderButtons={this.renderButtons}>
            <div>
                <ComplexParam dataItem={this.props.dataItem} autoApplyParams={false} showSearchBar={false}
                              renderParams={this.paramRender}
                              rowIndex={this.state.rowIndex}
                              customFieldExMap={this.props.customFieldExMap}
                />
            </div>
        </PopupWrapper>
            <PopupWrapper popupVisible={this.state.showScheduleVacationForm}
                          title={i18next.t("Vacation_Form_4", {year: this.getNumYear()})}
                          onClose={() => this.setState({showScheduleVacationForm: false})}>
                <GridView dataItem={this.props.ShedHolidayDetailListForPO} useItemStyle={true}/>
            </PopupWrapper>
        </>)
    }
}

VacationForm.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem: PropTypes.object,
    onClose: PropTypes.func,
    onDelete: PropTypes.func,
    title: PropTypes.string,
    readOnly: PropTypes.bool,
    addMode: PropTypes.bool.isRequired,
    rowKey: PropTypes.object,
    ShedHolidayDetailListForPO: PropTypes.object
};


VacationForm.defaultProps = {
    readOnly: false
};

function mapStateToProps(state, ownProps) {
    return {
        HolidayAppItemImage_Drop: state.vacationState.HolidayAppItemImage_Drop,
        ShedHolidayDetailListForPO: state.vacationState.ShedHolidayDetailListForPO
    }
}

export default connect(mapStateToProps)(VacationForm)